import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Button from '@material-ui/core/Button';

import { WizardStepContainer, WizardStepTitle } from './partials';
import { wizardChangeSearchOnboarding } from '../../../../../slices/OnboardingSlice';
import { useLocalizedMessage } from '../../../../../util/useLocalizedMessage';

const imageUrl = require('assets/wizard/wizard-finish.png');

const WizardFinishStep = ({ surfaceVariant }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const localizeMessage = useLocalizedMessage();
  const { shopId } = useSelector((state) => state.settings);
  const isCloudDataSurface = surfaceVariant === 'cloud-data';

  const handleClick = useCallback(() => {
    dispatch(wizardChangeSearchOnboarding({ wizardCompleted: true }));
    history.push(`/app/${shopId}/home`);
  }, [shopId, dispatch, history]);

  return (
    <div className="wizard-step wizard-step-finish">
      <WizardStepContainer>
        <div className="row">
          <div className="col-12">
            <div className="image-container">
              <img className="image" src={imageUrl} alt="" />
            </div>
          </div>
        </div>
        <div className="row title-row">
          <div className="col-12">
            <WizardStepTitle title={localizeMessage(isCloudDataSurface
              ? 'cloud.dataWizard.finish.title'
              : 'wizard.finish.title')} />
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-12">
            <div className="finish-text">
              <p className="finish-text__normal">
                {localizeMessage(isCloudDataSurface
                  ? 'cloud.dataWizard.finish.text.line1'
                  : 'wizard.finish.text.line1')}
              </p>
              <p className="finish-text__normal">
                {localizeMessage(isCloudDataSurface
                  ? 'cloud.dataWizard.finish.text.line2'
                  : 'wizard.finish.text.line2')}
              </p>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-12 text-center">
            <Button
              variant="contained"
              color="primary"
              className="mr-3"
              onClick={handleClick}
            >
              {localizeMessage('wizard.button.finish')}
            </Button>
          </div>
        </div>
      </WizardStepContainer>
    </div>
  );
};

WizardFinishStep.propTypes = {
  surfaceVariant: PropTypes.oneOf(['legacy', 'cloud-data']),
};

WizardFinishStep.defaultProps = {
  surfaceVariant: 'legacy',
};

export default WizardFinishStep;
